import {GetRecommendationsResponse_Recommendation} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {useTrackFeatureInViewImpression} from '@aboutyou/tracking';
import {
  BasketSection,
  Paper,
  mediaMobileOnly,
  mediaTabletAndUp,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {ProductTileProps} from '../../../features/ProductTile/ProductTile';
import {AddToBasketPayload} from '../../../features/ProductTile/types';
import {RecommendationsLane} from '../../../features/Recommendations/RecommendationsLane';

interface ComplementaryRecommendationProp
  extends GetRecommendationsResponse_Recommendation {
  onClickAddToBasket: (tile?: AddToBasketPayload) => void;
  smallerPaddings?: boolean;
  ProductTileComponent?: React.FC<ProductTileProps>;
  compactMode?: boolean;
  addToCTALabel?: string;
}

const TRACK_FEATURE_LABEL = 'basket-complementary-reco';

export const ComplementaryRecommendationView: React.FC<
  ComplementaryRecommendationProp
> = ({
  onClickAddToBasket,
  type: recommendation,
  smallerPaddings,
  ProductTileComponent,
  compactMode,
  addToCTALabel,
}) => {
  const {ref} = useTrackFeatureInViewImpression({label: TRACK_FEATURE_LABEL});

  switch (recommendation?.$case) {
    case 'products': {
      const {products, headline, subline, promotionTracking} =
        recommendation.products;

      if (products.length < 1) {
        return null;
      }

      return (
        <BasketSection>
          <StyledPaper $smallerPadding={smallerPaddings}>
            <div ref={ref as React.RefObject<HTMLDivElement | null>}>
              <StyledRecommendationsLane
                uniqueKey="products-complementary-recommendation"
                type="list"
                headline={headline}
                topline={subline}
                streamPosition={0}
                products={products}
                constrained
                promotionTracker={{
                  promotionId: promotionTracking.name,
                  promotionName: promotionTracking.name,
                  creativeName: promotionTracking.name,
                  creativeSlot: '0',
                  locationId: 'basket_complementary_recommendation',
                }}
                onAddToBasketCtaClick={
                  onClickAddToBasket
                    ? ({productId, couponPromotionId}) => {
                        const payload: AddToBasketPayload = {
                          product: {id: productId},
                          couponPromotionId,
                          badgesListKeys: [],
                        };
                        onClickAddToBasket(payload);
                      }
                    : undefined
                }
                ProductTileComponent={ProductTileComponent}
                addToCTALabel={addToCTALabel}
                hideSideButtons={compactMode}
                isSmallFormatHeader={true}
                trackComponentConfig={{
                  location_id: 'basket_complementary_recommendation',
                  page_type_id: 'basket',
                }}
                data-testid="products-complementary-recommendation-lane"
                centered
              />
            </div>
          </StyledPaper>
        </BasketSection>
      );
    }
  }
  return null;
};

const StyledRecommendationsLane = styled(RecommendationsLane)`
  margin-bottom: 0;
  padding-bottom: 0;
`;

const StyledPaper = styled(Paper)<{$smallerPadding?: boolean}>`
  &&& {
    padding-block: 0;
  }
  @media ${mediaTabletAndUp} {
    margin-bottom: 14px;
  }
  @media ${mediaMobileOnly} {
    border-radius: unset;
    &&& {
      padding-inline: 0;
    }
  }
`;
